








import { Component, Emit, Model, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import { getModule } from 'vuex-module-decorators';

const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: {},
})
export default class LeftNavDragBar extends Vue {
    private leftBarPosition: number;

    @Ref()
    drag!: HTMLDivElement;

    mounted() {
        this.setEvents();
    }

    setEvents() {
        const drag = this.drag;
        drag.addEventListener(
            'mousedown',
            (e) => {
                drag.style.transition = 'initial';
                document.body.style.cursor = 'col-resize';
                document.addEventListener('mousemove', this.resize, false);
                document.onselectstart = () => false;
            },
            false
        );

        document.addEventListener(
            'mouseup',
            () => {
                // console.log('mouseUp');
                drag.style.transition = '';
                // console.log(drawer.style.width);
                document.body.style.cursor = '';
                document.removeEventListener('mousemove', this.resize, false);
            },
            false
        );

        drag.addEventListener(
            'touchstart',
            (e) => {
                // console.log('touch');
                drag.style.transition = 'initial';
                document.body.style.cursor = 'col-resize';
                document.addEventListener('touchmove', this.resizeMobile, false);
            },
            false
        );
        document.addEventListener(
            'touchend',
            () => {
                // console.log('touch');
                drag.style.transition = '';
                // console.log(drawer.style.width);
                document.body.style.cursor = '';
                document.removeEventListener('touchmove', this.resizeMobile, false);
            },
            false
        );
        // console.log(drawerBorder);
    }

    resize(e: any) {
        let f = e.clientX;
        // console.log(f);
        if (f < 350) {
            this.leftPanelWidth = 260 + 'px';
        } else if (f > 890) {
            this.leftPanelWidth = 800 + 'px';
        } else {
            this.leftPanelWidth = f - 90 + 'px';
        }
    }

    resizeMobile(e: any) {
        let f = e.changedTouches[0].clientX;
        // console.log(f);
        if (f < 350) {
            this.leftPanelWidth = 260 + 'px';
        } else if (f > 890) {
            this.leftPanelWidth = 800 + 'px';
        } else {
            this.leftPanelWidth = f - 90 + 'px';
        }
    }

    get openLeft() {
        return workspaceOptionsModule.openLeft;
    }

    get leftPanelWidth() {
        return workspaceOptionsModule.leftPanelWidth;
    }

    set leftPanelWidth(val: string) {
        workspaceOptionsModule.setLeftPanelWidth(val);
    }
}
